module.exports = __webpack_public_path__ + "static/media/Quakers.aabfdb7f.PNG";